import { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

import Modal from '../modal/modal.component';

import styles from './warning-modal.module.scss';

interface Props {
    title: string;
    body: string;
    note?: string;
    extra?: ReactNode;
    onConfirm: () => void;
    onDiscard?: () => void;
    confirmText?: string;
    discardText?: string;
    confirmLoading?: boolean;
    confirmDisabled?: boolean;
    error?: string;
}

const WarningModal = ({
    title,
    body,
    note,
    extra,
    onConfirm,
    onDiscard,
    confirmText,
    discardText,
    confirmLoading,
    confirmDisabled,
    error,
}: Props) => {
    return (
        <Modal
            onConfirm={onConfirm}
            onDiscard={onDiscard}
            confirmText={confirmText}
            discardText={discardText}
            confirmLoading={confirmLoading}
            confirmDisabled={confirmDisabled}
        >
            <div className={styles.wrapper}>
                <div className={styles.icon}>
                    <AlertTriangle size={28} />
                </div>
                <h4 className={styles.title}>{title}</h4>
                <p className={styles.body}>{body}</p>
                {note && <p className={styles.note}>{note}</p>}
                {extra}
                {error && <p className={styles.error}>{error}</p>}
            </div>
        </Modal>
    );
};

export default WarningModal;
